import React, { memo } from 'react';
import BlockMarkdown from '../structured/BlockMarkdown';
import ClaimSupportFooter from '../ClaimSupportFooter';
import { extractBlockItems } from '../structured/structuredBlockUtils';
import styles from './consultantReport.module.css';

function severityTone(severity) {
    const value = String(severity || '').toLowerCase();
    if (value.includes('high') || value.includes('critical')) return 'high';
    if (value.includes('medium')) return 'medium';
    if (value.includes('low')) return 'low';
    return 'neutral';
}

function RiskPanel({ blocks, renderContext }) {
    const rows = blocks.flatMap(block =>
        extractBlockItems(block).map((item, index) => ({
            ...item,
            id: item.id || `${block.id}-risk-${index}`,
            block,
        })),
    );

    if (!rows.length) {
        return blocks.map(block => (
            <div key={block.id}>
                <BlockMarkdown content={block.content || block.markdown || ''} {...renderContext} />
                <ClaimSupportFooter block={block} renderContext={renderContext} />
            </div>
        ));
    }

    return (
        <div className={styles.riskPanelGrid}>
            {rows.map(row => {
                const title = row.risk || row.title || row.label;
                const severity = row.severity || row.ranked_severity;
                const tone = severityTone(severity);
                const cardClass =
                    tone === 'high'
                        ? styles.riskCardHigh
                        : tone === 'medium'
                          ? styles.riskCardMedium
                          : tone === 'low'
                            ? styles.riskCardLow
                            : '';
                return (
                    <article key={row.id} className={`${styles.riskCard} ${cardClass}`.trim()}>
                        {severity ? (
                            <span className={`${styles.riskSeverity} ${styles[`priority${tone}`] || ''}`.trim()}>
                                {severity}
                            </span>
                        ) : null}
                        {title ? (
                            typeof title === 'string' ? (
                                <BlockMarkdown content={title} {...renderContext} />
                            ) : (
                                <div>{title}</div>
                            )
                        ) : null}
                        {row.likelihood ? <div>Likelihood: {row.likelihood}</div> : null}
                        {row.owner ? <div>Owner: {row.owner}</div> : null}
                        {row.status ? <div>Status: {row.status}</div> : null}
                        <ClaimSupportFooter
                            block={{ ...row.block, citations: row.citations || row.supporting_refs || row.block?.citations }}
                            renderContext={renderContext}
                        />
                    </article>
                );
            })}
        </div>
    );
}

export default memo(RiskPanel);
